module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/keyboards-and-synths-7bd50b3e053d86bc0da7d52a05a78c9e.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/keyboards-and-synths.png
// module id = etwu
// module chunks = 9 12